// PB: Estimated Delivery – čte cut-off z data atributu .pb-ed[data-pb-cutoff]
(() => {
  const initialized = new WeakSet()
  let bodyObserver = null

  const roots = () => document.querySelectorAll('.pb-ed')
  const hasWidgets = () => roots().length > 0

  // Lokalizace
  const LOCALE = 'cs-CZ'
  const TZ = 'Europe/Prague'
  const fmtWeekday = new Intl.DateTimeFormat(LOCALE, { weekday: 'long', timeZone: TZ })
  const praguePartsFmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  })

  const ALLOWED_CUTOFFS = ['11:00', '12:00', '13:00', '14:00', '15:00']
  const inStock = (v) => !!v && (v.available || v.inventory_policy === 'continue' || (v.inventory_quantity ?? 0) > 0)
  const formatDate = (c) => `${c.d}. ${c.m}.`

  function parseBoolLike(v, fallback = false) {
    const s = String(v ?? '').trim().toLowerCase()
    if (!s) return fallback
    if (['pravda', 'true', '1', 'ano', 'yes', 'on'].includes(s)) return true
    if (['nepravda', 'false', '0', 'ne', 'no', 'off'].includes(s)) return false
    return fallback
  }

  function pragueNowParts(now = new Date()) {
    const parts = praguePartsFmt.formatToParts(now)
    const pick = (type) => parseInt(parts.find((p) => p.type === type)?.value || '0', 10)

    const y = pick('year')
    const m = pick('month')
    const d = pick('day')
    const h = pick('hour')
    const min = pick('minute')
    const day = new Date(Date.UTC(y, m - 1, d)).getUTCDay()

    return { y, m, d, h, min, day }
  }

  function addDaysCivil(civil, days) {
    const t = Date.UTC(civil.y, civil.m - 1, civil.d) + days * 86400000
    const dt = new Date(t)
    return {
      y: dt.getUTCFullYear(),
      m: dt.getUTCMonth() + 1,
      d: dt.getUTCDate(),
      day: dt.getUTCDay()
    }
  }

  function diffCivilDays(a, b) {
    return Math.round((Date.UTC(a.y, a.m - 1, a.d) - Date.UTC(b.y, b.m - 1, b.d)) / 86400000)
  }

  function civilToDateForTz(civil) {
    return new Date(Date.UTC(civil.y, civil.m - 1, civil.d, 12, 0, 0))
  }

  function parseHHMM(str) {
    const m = /^(\d{1,2}):(\d{2})$/.exec(String(str || ''))
    if (!m) return { h: 14, min: 0 }
    const h = Math.min(23, Math.max(0, parseInt(m[1], 10)))
    const min = Math.min(59, Math.max(0, parseInt(m[2], 10)))
    return { h, min }
  }

  function computeDeliveryInfo(activeCutoff) {
    const NOW = pragueNowParts()
    const { h, min } = parseHHMM(activeCutoff)

    const beforeCutoff = (civilNow) => (civilNow.h * 60 + civilNow.min) < (h * 60 + min)

    function nextDispatch(now = NOW) {
      const day = now.day
      if ((day === 2 || day === 4) && beforeCutoff(now)) return now

      let add
      if (day < 2) add = 2 - day
      else if (day < 4) add = 4 - day
      else add = (7 - day) + 2

      return addDaysCivil(now, add)
    }

    function nextDelivery(dispatchDate) {
      let dd = { ...dispatchDate }
      while (dd.day !== 3 && dd.day !== 5) dd = addDaysCivil(dd, 1)
      return dd
    }

    const DISPATCH = nextDispatch(NOW)
    const DELIVERY = nextDelivery(DISPATCH)
    const IS_TMR = diffCivilDays(DELIVERY, NOW) === 1

    const wd = fmtWeekday.format(civilToDateForTz(DELIVERY)).toLowerCase()
    const pred = (wd === 'středa' || wd === 'čtvrtek') ? 've' : 'v'
    const wdAkuz = (wd === 'středa') ? 'středu' : wd
    const df = formatDate(DELIVERY)

    return { IS_TMR, pred, wdAkuz, df }
  }

  function initEstimatedDelivery(root) {
    if (!root || initialized.has(root)) return
    initialized.add(root)

    let cutoff = (root.dataset.pbCutoff || root.getAttribute('data-pb-cutoff') || '14:00').trim()
    if (!ALLOWED_CUTOFFS.includes(cutoff)) cutoff = '14:00'

    const showDelivery = parseBoolLike(root.dataset.pbShowDelivery || root.getAttribute('data-pb-show-delivery'), false)

    const uid = root.id.replace('pb-ed-', '')
    const textEl = document.getElementById(`pb-ed-text-${uid}`)
    const dataEl = document.getElementById(`pb-ed-data-${uid}`)
    if (!textEl || !dataEl) return

    let product
    try { product = JSON.parse(dataEl.textContent || '{}') } catch { product = {} }

    const variants = Array.isArray(product?.variants) ? product.variants : []
    const VARS = {}
    for (let i = 0; i < variants.length; i++) VARS[String(variants[i].id)] = variants[i]

    function inStockHtml() {
      if (!showDelivery) return 'Skladem'
      const { IS_TMR, pred, wdAkuz, df } = computeDeliveryInfo(cutoff)
      if (IS_TMR) return `Skladem - doručíme zítra ${df}`
      return `Skladem - doručíme ${pred}  ${wdAkuz} ${df}`
    }

    function messageFor(variantId) {
      const key = String(variantId ?? '')
      const v = VARS[key]
      if (!inStock(v)) return 'Brzy opět skladem – do 14 dnů'
      return inStockHtml()
    }

    function updateByVariantId(variantId) {
      const id = String(variantId ?? '')
      textEl.innerHTML = id ? messageFor(id) : 'Brzy opět skladem – do 14 dnů'
    }

    const container = root.closest('.shopify-section') || document.body

    const sameProduct = (eProductId) => {
      const pidA = String(eProductId ?? '')
      const pidB = String(product?.id ?? '')
      return !pidA || !pidB || pidA === pidB
    }

    const onVariantUpdate = (e) => {
      if (!sameProduct(e?.detail?.data?.productId || e?.detail?.productId)) return
      updateByVariantId(e?.detail?.resource?.id)
    }
    container.addEventListener('variant:update', onVariantUpdate, { passive: true })

    const form = container.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]')
    let idInput = form?.querySelector('input[name="id"]')

    const wireIdInput = (el) => {
      if (!el || el.dataset.pbEdWired === '1') return
      el.dataset.pbEdWired = '1'

      const onChange = () => updateByVariantId(el.value)
      el.addEventListener('change', onChange, { passive: true })
      new MutationObserver(onChange).observe(el, { attributes: true, attributeFilter: ['value'] })
    }

    const urlVariantId = new URLSearchParams(window.location.search).get('variant')
    if (urlVariantId) updateByVariantId(urlVariantId)
    else if (idInput?.value) updateByVariantId(idInput.value)
    else if (variants.length) updateByVariantId((variants.find(inStock) || variants[0]).id)

    wireIdInput(idInput)

    const waitForIdInput = new MutationObserver(() => {
      if (idInput && idInput.isConnected) return

      idInput = (form || container).querySelector?.('form[action*="/cart/add"] input[name="id"]')
        || document.querySelector('form[action*="/cart/add"] input[name="id"]')

      if (idInput) {
        wireIdInput(idInput)
        if (idInput.value) updateByVariantId(idInput.value)
        waitForIdInput.disconnect()
      }
    })
    waitForIdInput.observe(container, { subtree: true, childList: true })

    ;(window.requestAnimationFrame || setTimeout)(() => {
      if (idInput?.value) updateByVariantId(idInput.value)
    }, 0)
  }

  function initAll() {
    const list = roots()
    if (!list.length) return
    list.forEach(initEstimatedDelivery)

    if (!bodyObserver) {
      bodyObserver = new MutationObserver((muts) => {
        for (let i = 0; i < muts.length; i++) {
          const m = muts[i]
          if (!m.addedNodes) continue
          for (let j = 0; j < m.addedNodes.length; j++) {
            const n = m.addedNodes[j]
            if (n.nodeType !== 1) continue
            if (n.classList?.contains('pb-ed')) initEstimatedDelivery(n)
            n.querySelectorAll?.('.pb-ed').forEach(initEstimatedDelivery)
          }
        }
      })
      bodyObserver.observe(document.body, { childList: true, subtree: true })
    }
  }

  const start = () => { if (hasWidgets()) initAll() }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true })
  else start()

  document.addEventListener('shopify:section:load', start)
  document.addEventListener('shopify:section:select', start)
})()
